import { Controller } from "stimulus";
import Chart from 'chart.js/auto';

export default class extends Controller {

  static targets = ['graph'];

  connect() {
    const graph = this.graphTarget;
    const data = JSON.parse(graph.dataset.results);
    const max = parseInt(graph.dataset.max, 10);
    
    new Chart(graph, {
      type: 'line',
      options: {
        scales: {
          y: {
            min: 0,
            max: max,
          }
        }
      },
      data: {
        labels: data.map(row => row.date),
        datasets: [
          {
            label: "SLP Ratings",
            data: data.map(row => row.rating),
            backgroundColor: "#698f3f",
            borderColor: "#cfff00"
          },
        ]
      }
    })
  }

}